import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../layouts';
import GeneralView from '../components/SettingsModal/GeneralView';
import SessionsView from '../components/SettingsModal/SessionsView';
import { GridIcon, TabletIcon } from '../icons';

const tabs = [
  { id: 'general', label: 'General', icon: GridIcon },
  { id: 'sessions', label: 'Sessions', icon: TabletIcon },
];

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('general');
  const navigate = useNavigate();

  return (
    <DashboardLayout onBackClick={() => navigate(-1)}>
      <div className="h-full overflow-auto">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8">

          {/* Page title */}
          <h1 className="text-2xl font-bold tracking-tight text-[#121212] dark:text-[#D0D0D0] mb-6">
            Settings
          </h1>

          {/* Tabs */}
          <div className="flex items-center gap-1 mb-8 border-b border-[#ECECEC] dark:border-[#202020]">
            {tabs.map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                onClick={() => setActiveTab(id)}
                className={`flex items-center gap-2 px-3 py-2 mb-[-1px] text-xs font-semibold border-b-2 transition-colors ${
                  activeTab === id
                    ? 'border-[#121212] dark:border-[#D0D0D0] text-[#121212] dark:text-[#D0D0D0]'
                    : 'border-transparent text-[#7B7B7B] dark:text-[#848484] hover:text-[#121212] dark:hover:text-[#D0D0D0]'
                }`}
              >
                <Icon size={14} className="shrink-0" />
                {label}
              </button>
            ))}
          </div>

          {/* Content */}
          {activeTab === 'general' && <GeneralView />}
          {activeTab === 'sessions' && <SessionsView />}



        </div>
      </div>
    </DashboardLayout>
  );
};

export default SettingsPage;
